var getSingleResourceDescription = function(param) {
    var hasProjectState = param.hasProjectState, isProjectsError = param.isProjectsError, resourceName = param.resourceName;
    var hasResourceName = resourceName.length > 0;
    if (hasProjectState) {
        if (isProjectsError) {
            return hasResourceName ? "DeleteSingleResourcePrompt.description.projectSpecific.error" : "DeleteSingleResourcePrompt.description.projectSpecific.error.noResourceName";
        }
        return hasResourceName ? "DeleteSingleResourcePrompt.description.projectSpecific" : "DeleteSingleResourcePrompt.description.projectSpecific.noResourceName";
    }
    return hasResourceName ? "DeleteSingleResourcePrompt.description.default" : "DeleteSingleResourcePrompt.description.default.noResourceName";
};
export var DeleteSingleResourcePromptHelpers = {
    getSingleResourceDescription: getSingleResourceDescription
};

//# sourceMappingURL=DeleteSingleResourcePromptHelpers.js.map